import {
  Button,
  Link,
  NotificationCard,
  RHFTextField,
  Section,
} from "@arp/react-ndbx";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Fade, Modal, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import React, { useEffect, useState } from "react";
import { URLS, optVerificationModalContent } from "../../../config/const/enums";
import { useSendOtpMutation } from "../../../hooks/dataHooks/useSendOtpMutation";
import usePreQualification from "../../../hooks/usePreQualification";
import useSharedData from "../../../hooks/useSharedData";
import { getModalDefaultStyle } from "../../../utilities/getFontValues";
import { formatMobileNumberMasked } from "../../../utilities/mappingHelper";
import OtpVerificationCodeModal from "./OtpVerificationCodeModal";

function OtpVerificationModal({
  openOtpVerification,
  handleOtpVerificationClose,
  verifyOtpNumberModal,
  otpSendSuccess,
  person = "personOne",
}) {
  const theme = useTheme();
  const { dataSet } = usePreQualification();
  const [sendOtpLoading, setSendOtpLoading] = useState(false);
  const [oktaErrorFlag, setOktaErrorFlag] = useState(false);
  const [oktaErrorMessage, setOktaErrorMessage] = useState("");
  const { accessToken } = useSharedData();
  // const accessToken = getAzureJWTToken();

  const style = getModalDefaultStyle(theme);
  const mutation = useSendOtpMutation();

  useEffect(() => {
    setOktaErrorFlag(false);
    if(openOtpVerification && "true" === import.meta.env.VITE_SKIP_SEND_SMS_MODAL) {
      verifyOtpNumberModal();
      sendOtpCode();
    }
  }, [openOtpVerification]);

  const sendOtpCode = async () => {
    try {
      setSendOtpLoading(true);
      const smsChallengeResponse = await mutation.mutateAsync(accessToken);
      if (smsChallengeResponse?.status === 200) {
        setTimeout(() => {
          setSendOtpLoading(false);
          verifyOtpNumberModal();
        }, 1000);
      } else {
        setOktaErrorFlag(true);
        if (smsChallengeResponse?.response?.status === 429) {
          setOktaErrorMessage(optVerificationModalContent.SMS_SEND_WAIT);
        } else {
          setOktaErrorMessage(optVerificationModalContent.GENERIC_SMS_ERROR);
        }
        setSendOtpLoading(false);
      }
    } catch (error) {
      // console.error("Error occured while sending SMS - ", error);
      setOktaErrorFlag(true);
      setOktaErrorMessage(optVerificationModalContent.GENERIC_SMS_ERROR);
      setSendOtpLoading(false);
    }
  };

  return (
    <Modal open={openOtpVerification} onClose={handleOtpVerificationClose}>
      <Box sx={style} data-identifier="save-send-email-modal">
        <Section
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            mt: 0,
            mb: 0,
            mr: { xs: 1, sm: 3 },
            position: "sticky",
            // position: "-webkit-sticky",
            top: { xs: 16, sm: 24 },
          }}
        >
          <CloseIcon
            onClick={handleOtpVerificationClose}
            justify="center"
            alignItems="center"
            sx={{ cursor: "pointer" }}
          ></CloseIcon>
        </Section>
        {!otpSendSuccess && (
          <Section
            sx={{
              pl: { xs: 3, sm: 8 },
              pr: { xs: 3, sm: 8 },
              pt: { xs: 5 },
              mt: 0,
              mb: 0,
            }}
          >
            <Section sx={{ mt: 0, mb: 3 }}>
              <Typography variant="h3-bold">
                {optVerificationModalContent.ALLIANZ_INFORMATION}
              </Typography>
            </Section>
            <Section sx={{ maxWidth: { xs: 258 }, mb: 4 }}>
              <Section md={12} mt={{ sm: 2, md: 4 }}>
                <RHFTextField
                  className="subvariant-text-input"
                  variant="standard"
                  label="Mobile number"
                  name="mobileNumber"
                  defaultValue={formatMobileNumberMasked(
                    dataSet[person].contactNumber
                  )}
                  type="phone"
                  disabled
                />
              </Section>
            </Section>

            <Section sx={{ mb: 3, mt: 0 }}>
              <Typography
                id="modal-modal-description"
                variant="p3"
                sx={{ mt: 2 }}
              >
                {optVerificationModalContent.MOBILE_NUMBER_OTP}
              </Typography>
            </Section>
            <Section mb={4}>
              <Fade in={true} timeout={500}>
                <Box>
                  <NotificationCard
                    cardType="info"
                    title="Important information"
                    message={
                      <>
                        If the information you've provided is incorrect, call
                        our friendly Life Insurance Specialists on{" "}
                        <Link href={URLS.CONTACT_US_PHONE_URL}>
                          {URLS.CONTACT_US_PHONE_NUMBER}
                        </Link>{" "}
                        to discuss your application.
                      </>
                    }
                  />
                </Box>
              </Fade>
            </Section>
            {oktaErrorFlag && (
              <Section mb={4}>
                <Fade in={true} timeout={500}>
                  <Box>
                    <NotificationCard
                      cardType="error"
                      title=""
                      message={oktaErrorMessage}
                    />
                  </Box>
                </Fade>
              </Section>
            )}
            <Section mb={3}>
              <Section sx={{ maxWidth: { xs: "250px" } }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={sendOtpCode}
                  disabled={sendOtpLoading}
                >
                  {optVerificationModalContent.SEND_CODE_SMS}
                </Button>
              </Section>
            </Section>
          </Section>
        )}
        {otpSendSuccess && (
          <OtpVerificationCodeModal
            userMobileNumber={dataSet[person].contactNumber}
          />
        )}
      </Box>
    </Modal>
  );
}

export default OtpVerificationModal;
